import { createRouter, createWebHistory } from 'vue-router'
import WorkbenchLayout from '@/layouts/WorkbenchLayout.vue'

// --- 新增引入 Home 相关的介绍页面 ---
import LandingView from '@/views/LandingView.vue'
import UsageGuideView from '@/views/UsageGuideView.vue'
import EnterpriseServicesView from '@/views/EnterpriseServicesView.vue'
// ---------------------------------

import RemoveView from '@/views/RemoveView.vue'
import PromoView from '@/views/PromoView.vue'
import FissionView from '@/views/FissionView.vue'
import AmazonCopyView from '@/views/AmazonCopyView.vue'
import KeywordRadarView from '@/views/KeywordRadarView.vue'
import PromoVideoView from '@/views/PromoVideoView.vue'
// import DocsView from '@/views/DocsView.vue'
import AccountView from '@/views/AccountView.vue'
import PaymentView from '@/views/PaymentView.vue'
import SizeChartView from '../views/SizeChartView.vue'
import LoginView from '@/views/LoginView.vue' 

const routes = [
  // --- 新增前端公开路由 ---
  {
    path: '/home',
    name: 'home',
    component: LandingView,
    meta: { title: '智磐 AI - 跨境电商素材工厂' }
  },
  {
    path: '/home/usage',
    name: 'home-usage',
    component: UsageGuideView,
    meta: { title: '使用说明 - 智磐 AI' }
  },
  {
    path: '/home/services',
    name: 'home-services',
    component: EnterpriseServicesView,
    meta: { title: '企业服务 - 川岳智磐' }
  },
  // ----------------------
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: WorkbenchLayout,
    children: [
      // 【修改】默认访问根目录时，重定向到 /home 介绍页，而不是直接进工作台
      { path: '', redirect: '/home' },

      {
        path: '/remove',
        name: 'remove',
        component: RemoveView,
        meta: {
          navKey: 'remove',
          breadcrumb: '抠图工作台',
          title: '抠图工作台',
          subTitle: '本地抠图或豆AI抠图 + 背景重绘'
        }
      },
      {
        path: '/promo',
        name: 'promo',
        component: PromoView,
        meta: {
          navKey: 'promo',
          breadcrumb: '宣传图生成',
          title: '宣传图生成',
          subTitle: '基于抠图结果和产品信息，生成多张宣传镜头图'
        }
      },
      {
        path: '/fission',
        name: 'fission',
        component: FissionView,
        meta: {
          navKey: 'fission',
          breadcrumb: '裂变图生成',
          title: '裂变图生成',
          subTitle: '基于已生成的宣传图背景，替换不同颜色或型号的商品'
        }
      },
      {
        path: '/amazon-copy',
        name: 'amazon-copy',
        component: AmazonCopyView,
        meta: {
          navKey: 'amazonCopy',
          breadcrumb: 'Amazon文案生成',
          title: 'Amazon文案生成',
          subTitle: '基于视觉分析自动撰写 Amazon Listing'
        }
      },
      {
        path: '/keyword-radar',
        name: 'keyword-radar',
        component: KeywordRadarView,
        meta: {
          navKey: 'keywordRadar',
          breadcrumb: '流量雷达',
          title: '流量雷达',
          subTitle: '分析关键词在 Amazon 市场的搜索热度与趋势'
        }
      },
      {
        path: '/size-chart',
        name: 'size-chart',
        component: SizeChartView,
        meta: {
          navKey: 'sizeChart', // 👉 把这里改成 sizeChart
          breadcrumb: '中外转换工作台',
          title: '中外转换工作台',
          subTitle: '上传商品图,AI自动转换为美国标准尺码表'
        }
      },
      {
        path: '/promo-video',
        name: 'promo-video',
        component: PromoVideoView,
        meta: {
          navKey: 'promoVideo',
          breadcrumb: '宣传视频生成',
          title: '宣传视频生成',
          subTitle: '选择宣传图，生成宣传视频'
        }
      },
      // {
      //   path: '/docs',
      //   name: 'docs',
      //   component: DocsView,
      //   meta: {
      //     navKey: 'docs',
      //     breadcrumb: 'API / 使用说明',
      //     title: 'API / 使用说明',
      //     subTitle: '接口列表、环境变量与安装指引'
      //   }
      // },
      {
        path: '/account',
        name: 'account',
        component: AccountView,
        meta: {
          navKey: 'account',
          breadcrumb: '账号管理',
          title: '账号管理',
          subTitle: '账户基础信息与安全快捷入口'
        }
      },
      {
        path: '/payment',
        name: 'payment',
        component: PaymentView,
        meta: {
          navKey: 'account',
          breadcrumb: '算力充值',
          title: '算力充值',
          subTitle: '选择套餐，扫码支付'
        }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router